<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="cts" id="pz23-1"><a id="page_11"></a><a href="#/contents#RR_21" id="CC_21"> <i>Breads</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter21.vue?5bc005c6